<template>
  <div>
    <nav-breadcrumb :menu="[{label :'放款登记'}]"/>
    <el-form label-width="170px" class="xzformitemmb" :model="financingDetail" ref="dataForm">
      <el-row>
        <panel title="放款信息" border>
          <el-col :span="12">
            <el-form-item label="收款账号：">
              {{financingDetail.pay__customerAccountNo}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="户名：">
              {{financingDetail.pay__customerAccountName}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="开户行：">
              {{financingDetail.pay__customerAccountBankName}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="放款金额：">
              {{financingDetail.pay__totalAmount|formatMoney}} 元
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="放款方式：" prop="pay__channel" >
              {{financingDetail.pay__channel|Status2CN}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="放款日期：" prop="pay__paymentDate" :rules="{required: true, message: '日期不能为空'}" >
              <el-date-picker
                v-model="financingDetail.pay__payDate"
                value-format="yyyy-MM-dd"
                format="yyyy-MM-dd"
                type="date"
                placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="付款账户：" prop="pay__payAccountId" :rules="{required: true, message: '付款账户不能为空'}" style="width: 100%">
              <el-select placeholder="请选择付款账户" v-model.trim="financingDetail.pay__payAccountId"style="width:100%">
                <el-option :label="item.label" :value="item.value" v-for="(item,idx) in payAccountOptions" :key="idx"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="放款流水号：">
              <el-input v-model="financingDetail.pay__reference" style="margin-bottom:10px;"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="摘要：">
              <el-input type="textarea" v-model="financingDetail.pay__txUse" style="margin-bottom:10px;"></el-input>
            </el-form-item>
          </el-col>
        </panel>
      </el-row>
    </el-form>
    <div class="tr xzmt">
      <el-button type="primary" @click="onSubmit('dataForm')">提交</el-button>
      <el-button plain @click="$router.go(-1)">返回</el-button>
    </div>
  </div>
</template>

<script>
  import xhr from '../../utils/xhr'
  import moment from 'moment'
  import Status2CN from "../../filters/Status2CN";
  import {formatMoney} from "../../filters/CommonFilters";
  import bankCodeOptions from "../../utils/bankCodeOptions"
    export default {
        name: "PayFinancingBANKTRANSFER",
      data() {
        return {
          financingDetail: {
            t__customerBankCode:'',
            pay__paymentDate: ''
          },
          payAccountOptions:[],
        }
      },
      filters: {

        Status2CN
      },
      mounted(){
        this.getData()
        this.getBankAccountList()
      },
      methods:{
        getData:function () {
          xhr.getViewFinancingPaymentForApproval({
              'pay.applicationId': this.$route.query['applicationId']
            },
            res => {
              try {
                if (res.data.status == 'success') {
                  this.financingDetail = res.data.data
                /*  if(this.financingDetail.pay__paymentDate) {
                    this.$set(this.financingDetail, 'pay__payDate', this.financingDetail.pay__paymentDate)
                  }*/
                  if(this.financingDetail.cb__bank.split("银行").length>1){
                    this.financingDetail.t__customerBankCode = bankCodeOptions[this.financingDetail.cb__bank.split("银行")[0]+'银行']
                  }


                }
              } catch (e) {

              }
            })
        },
        getBankAccountList: function () {
          xhr.getBankAccountList({},res=>{
            try{
              if(res.data.status == 'success') {
                this.payAccountList = res.data.data||[]
                this.payAccountOptions = this.payAccountList.map(item=>{
                  return {
                    key: item['ba__accountId'],
                    label: item['ba__bank']+'-'+item['ba__accountName']+'-'+item['ba__accountNo'],
                    value: item['ba__accountId'],
                    name: item['ba__bank'],
                    accountName: item['ba__accountName'],
                    accountNo: item['ba__accountNo'],
                  }
                })
              }
            }catch (e) {

            }
          })
        },

        onSubmit:function (formName) {
          this.$refs[formName].validate(valid=> {
            if (valid) {
              const fnSubmit = ()=> {
                let onSubmitFrom = {
                }
                onSubmitFrom.pay__transactionId = this.financingDetail.pay__transactionId
                onSubmitFrom.pay__payAccountId = this.financingDetail.pay__payAccountId
                onSubmitFrom.pay__payDate = moment(this.financingDetail.pay__payDate).format('YYYY-MM-DD 00:00:00')
                onSubmitFrom.pay__txUse = this.financingDetail.pay__txUse
                onSubmitFrom.pay__reference = this.financingDetail.pay__reference
                onSubmitFrom.pay__channel = this.financingDetail.pay__channel
                onSubmitFrom.pay__customerAccountNo = this.financingDetail.pay__customerAccountNo
                onSubmitFrom.pay__customerAccountName = this.financingDetail.pay__customerAccountName
                onSubmitFrom.pay__customerAccountBankName = this.financingDetail.pay__customerAccountBankName
                onSubmitFrom.pay__loanAccountId = this.financingDetail.pay__customerAccountId


                xhr.updatePayFinancing(onSubmitFrom, res=> {
                  try {
                    if (res.data.status == 'success') {

                      this.$router.push({
                        path: 'List'
                      })
                    }
                  } catch (e) {
                  }
                })
              }

              if( this.financingDetail.pay__paymentDate != this.financingDetail.pay__payDate) {
                this.$confirm('您输入的放款日期与申请的放款日期不一致， 请输入实际的网银转账日期！')
                .then(()=> {
                  fnSubmit()
                })
                .catch(()=> {

                })
              }
              else {
                fnSubmit()
              }
            }
          })
        }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/fang/PayFinancingBANKTRANSFER.vue